var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32349 2.4707L10.3999 12.1265C10.7251 12.4725 11.2748 12.4725 11.6 12.1265L20.6764 2.4707",
    stroke: "#C691FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3.70629C1 2.84537 1.69791 2.14746 2.55882 2.14746H19.4412C20.3021 2.14746 21 2.84537 21 3.70628V17.2945C21 18.1554 20.3021 18.8533 19.4412 18.8533H2.55882C1.69791 18.8533 1 18.1554 1 17.2945V3.70629Z",
    stroke: "#C691FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.d097eca09724659fed1ec97b9a47a29b.svg";
export { ForwardRef as ReactComponent };